import styled from '@emotion/styled';

import { device, useRevealTrail } from '@landsbankinn/ui';
import React from 'react';

interface IProps {
  children: React.ReactNode;
  align: 'Left' | 'Right';
}

const Host = styled.div<{ align: string }>`
  @media ${device.tablet} {
    display: -ms-grid;
    display: grid;
    grid-template-columns: ${(props) =>
      props.align === 'Left' ? '2fr 1fr' : '1fr 2fr'};
    -ms-grid-columns: ${(props) =>
      props.align === 'Left' ? '2fr 20px 1fr' : '1fr 20px 2fr'};
    grid-template-rows: 0.5fr 0.5fr 0.5fr 0.5fr;
    -ms-grid-rows: 0.5fr 20px 0.5fr 20px 0.5fr 20px 0.5fr;
    gap: 20px 20px;
    grid-template-areas: ${(props) =>
      props.align === 'Left'
        ? `
      'item1 item3'
      'item1 item4'
      'item1 item5'
      'item2 item6'`
        : `
      'item3 item1'
      'item4 item1'
      'item5 item1'
      'item6 item2'
      `};

    > *:first-child {
      ${(props) =>
        props.align === 'Left'
          ? `-ms-grid-row: 1;
            -ms-grid-row-span: 5;
            -ms-grid-column: 1;`
          : `-ms-grid-row: 1;
            -ms-grid-row-span: 5;
            -ms-grid-column: 3;`}
      grid-area: item1;
    }

    > *:nth-child(2) {
      ${(props) =>
        props.align === 'Left'
          ? `-ms-grid-row:7;
            -ms-grid-column:1;`
          : `-ms-grid-row:7;
            -ms-grid-column:3;`}

      grid-area: item2;
    }

    > *:nth-child(3) {
      ${(props) =>
        props.align === 'Left'
          ? `-ms-grid-row:1;
            -ms-grid-column:3;`
          : `-ms-grid-row:1;
            -ms-grid-column:1;`}

      grid-area: item3;
    }

    > *:nth-child(4) {
      ${(props) =>
        props.align === 'Left'
          ? `-ms-grid-row:3;
            -ms-grid-column:3;`
          : `-ms-grid-row:3;
            -ms-grid-column:1;`}

      grid-area: item4;
    }

    > *:nth-child(5) {
      ${(props) =>
        props.align === 'Left'
          ? `-ms-grid-row:5;
            -ms-grid-column:3;`
          : `-ms-grid-row:5;
            -ms-grid-column:1;`}

      grid-area: item5;
    }

    > *:nth-child(6) {
      ${(props) =>
        props.align === 'Left'
          ? `-ms-grid-row:7;
            -ms-grid-column:3;`
          : `-ms-grid-row:7;
            -ms-grid-column:1;`}

      grid-area: item6;
    }
  }

  @media ${device.desktop} {
    grid-template-rows: 1fr 0.5fr 1fr 0.5fr;
    -ms-grid-rows: 1fr 20px 0.5fr 20px 1fr 20px 0.5fr;
  }
`;

export const FeaturedGroup = ({ children, align }: IProps) => {
  const { ref, itemsWithStyleProp } = useRevealTrail(children);
  return (
    <Host ref={ref} align={align}>
      {itemsWithStyleProp}
    </Host>
  );
};
